const quickActionsModels = {
  appointment: {
    name: 'appointment',
    icon: 'appointment',
    text: 'common.quick_actions_menu.appointment',
  },
  client: {
    name: 'client',
    icon: 'add-client',
    text: 'common.quick_actions_menu.client_vue',
  },
  message: {
    name: 'message',
    icon: 'new-message',
    text: 'common.quick_actions_menu.message',
  },
  invoice: {
    name: 'invoice',
    icon: 'invoice',
    text: 'common.quick_actions_menu.invoice',
  },
  record_payment: {
    name: 'record_payment',
    icon: 'payments',
    text: 'common.quick_actions_menu.record_payment',
  },
  accept_payment: {
    name: 'accept_payment',
    icon: 'credit-card',
    text: 'common.quick_actions_menu.accept_payment',
  },
  portal: {
    name: 'portal',
    icon: 'invite-to-portal',
    text: 'common.quick_actions_menu.portal',
  },
  pay: {
    name: 'pay',
    icon: 'request-payment',
    text: 'common.quick_actions_menu.pay',
  },
  schedule: {
    name: 'schedule',
    icon: 'invite-to-schedule',
    text: 'common.quick_actions_menu.schedule',
  },
  document: {
    name: 'document',
    icon: 'document',
    text: 'common.quick_actions_menu.document',
  },
  share_document: {
    name: 'share_document',
    icon: 'document',
    text: 'common.quick_actions_menu.share_document',
  },
  internal_document: {
    name: 'internal_document',
    icon: 'internal_document',
    text: 'common.quick_actions_menu.internal_document',
  },
  request_signature: {
    name: 'request_signature',
    icon: 'request_signature',
    text: 'common.quick_actions_menu.request_signature',
  },
  estimate: {
    name: 'estimate',
    icon: 'estimate',
    text: 'common.quick_actions_menu.estimate',
  },
  announcement: {
    name: 'announcement',
    icon: 'send-promotion',
    text: 'common.quick_actions_menu.announcement',
  },
  register_to_event: {
    name: 'register_to_event',
    icon: 'register-to-event',
    text: 'common.quick_actions_menu.register_to_event',
  }
}

const pick = (...actions) => {
  return actions.map(action => quickActionsModels[action])
}

export default {
  pick,
}

export const quickActionsService = {
  pick
}
